import React, { Component } from 'react'

export default class HoverDelay extends Component {
  timeout
  hovering = false
  elementRef = React.createRef()

  componentDidMount () {
    const element = this.elementRef.current
    element.addEventListener('mouseover', this.onMouseOver, false)
    element.addEventListener('mouseout', this.onMouseOut, false)
  }

  componentWillUnmount () {
    const element = this.elementRef.current
    if (this.timeout) clearTimeout(this.timeout)
    element.removeEventListener('mouseover', this.onMouseOver, false)
    element.removeEventListener('mouseout', this.onMouseOut, false)
    element.removeEventListener('mouseout', this.onMouseMove, false)
  }

  onMouseOver = event => {
    const element = this.elementRef.current

    if (this.timeout) clearTimeout(this.timeout)
    element.addEventListener('mousemove', this.onMouseMove, false)
  }

  onMouseMove = event => {
    const { delay } = this.props
    if (!this.hovering) {
      this.hovering = true
      this.timeout = setTimeout(() => {
        this.props.onMouseOver(event)
      }, delay)
    }
  }

  onMouseOut = event => {
    const element = this.elementRef.current
    this.hovering = false
    clearTimeout(this.timeout)
    this.props.onMouseOut(event)
    element.removeEventListener('mouseout', this.onMouseMove, false)
  }

  render () {
    return React.cloneElement(this.props.children, {
      ref: this.elementRef
    })
  }
}
